import React from 'react';
import PropTypes from 'prop-types';
import Typography from '../../components/Typography';

const MenuItems = ({ buttons }) => (
  <div className="menu-items">
    {buttons.map((button) => (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <div
        key={button.key}
        onClick={() => {
          if (button.disabled) {
            return;
          }
          button.onClick();
        }}
        aria-disabled={button.disabled}
        className={`nav-btn ${button.disabled ? 'nav-btn--disabled' : ''} ${button.link && window.location.pathname === button.link && !button.noHighlightOnSelect && !button.disabled && 'add-menu-item-selected-highlight'}`}
      >
        <div className="nav-icon">
          {(button.badgeText || button.badgeCount) && (
            <div className={`badge ${button.badgeText ? 'badge--small' : ''}`}>{button.badgeText || button.badgeCount}</div>
          )}
          {button.dot && <div className="dot" />}
          {button.icon}
        </div>
        <Typography variant="text" size="xxsmall" color="inherit">
          {button.label}
        </Typography>
      </div>
    ))}
  </div>
);

MenuItems.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    link: PropTypes.string,
    noHighlightOnSelect: PropTypes.bool,
    badgeCount: PropTypes.number,
    badgeText: PropTypes.string,
    dot: PropTypes.bool,
    disabled: PropTypes.bool,
    icon: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
};

export default MenuItems;
